import React from "react";
import { CheckIcon, XIcon } from "lucide-react";
import { Accent, Container, CtaButton, SectionHeader } from "./ui";
import { checkout, comparison, tagline } from "../data/content";
export function ClosingSection() {
  return <section className="bg-white py-12 md:py-24" data-id="element-40" data-mp="12uevth80glc7">
      <Container data-id="element-41" data-mp="xu0mlvuob5cl">
        <SectionHeader eyebrow="Two ways to start your year" title={<>
              Keep planning at night, or <Accent data-id="element-43" data-mp="1cpgh21z6139i">walk in ready</Accent>
            </>} data-id="element-42" data-mp="xthef6utrvbr" />
        <div className="mx-auto grid max-w-[960px] grid-cols-1 gap-4 md:grid-cols-2 md:gap-5" data-id="element-44" data-mp="17qvlwgyrt9rx">
          <div className="rounded-2xl border border-line bg-cream p-5 md:p-8" data-id="element-45" data-mp="1lia44lkut6xx">
            <h3 className="font-display text-[26px] font-bold uppercase leading-none text-muted md:text-[28px]" data-id="element-46" data-mp="1hh82xz7dmktb">
              Without the kit
            </h3>
            <ul className="mt-5 space-y-3.5" data-id="element-47" data-mp="1vfetsvdwrkjh">
              {comparison.without.map(item => <li key={item} className="flex gap-3 text-muted" data-id="element-48" data-mp="1qgbn76ia569e">
                  <XIcon className="mt-1 h-4 w-4 shrink-0 text-muted" strokeWidth={3} aria-hidden="true" data-id="element-49" data-mp="22dnmfl80lv8h" />
                  {item}
                </li>)}
            </ul>
          </div>
          <div className="rounded-2xl border-2 border-petrol bg-sage p-5 md:p-8" data-id="element-50" data-mp="2c9qq4viim1xj">
            <h3 className="font-display text-[26px] font-bold uppercase leading-none text-petrol md:text-[28px]" data-id="element-51" data-mp="2gcdhywf6rmuq">
              With the kit
            </h3>
            <ul className="mt-5 space-y-3.5" data-id="element-52" data-mp="2l9dot9jv0tmw">
              {comparison.with.map(item => <li key={item} className="flex gap-3 text-ink" data-id="element-53" data-mp="2q7yi0p0p2d1u">
                  <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-petrol" strokeWidth={3} aria-hidden="true" data-id="element-54" data-mp="2v1jhymlulh3o" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-10 max-w-[560px] text-center md:mt-12" data-id="element-55" data-mp="343iwn89e493g">
          <p className="font-display text-[28px] font-bold uppercase leading-tight text-petrol" data-id="element-56" data-mp="391kj8360yqjo">{tagline}</p>
          <p className="mt-3 text-base text-muted sm:text-lg" data-id="element-57" data-mp="18z2roac0uuj7">
            1 activity book · 10 activities · 12-month calendar · 5 bonuses
            <br data-id="element-58" data-mp="1iocmhxy92rb0" />
            <strong className="text-ink" data-id="element-59" data-mp="1iow7jnj75vt9">
              ${checkout.price} {checkout.currency}, one-time payment · 10-day guarantee
            </strong>
          </p>
          <CtaButton href="#offer-details" className="mt-7 w-full" data-id="element-60" data-mp="1dvt9p37e0079">
            Get the activity kit
          </CtaButton>
        </div>
      </Container>
    </section>;
}